import { render } from "./Background.vue?vue&type=template&id=41ced58d&scoped=true"
const script = {}

import "./Background.vue?vue&type=style&index=0&id=41ced58d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ced58d"]])

export default __exports__